export default "__VITE_ASSET__B3$dd6EW__"